<script lang="ts">
	import Image from '$lib/components/image.svelte';
	import type { UploadFileFieldsFragment } from '$lib/graphql/strapiApi';
	import { replaceImg } from '$lib/utils.js';

	type Feature = {
		title?: string | null;
		imagePlacement?: string | null;
		description?: string | null;
		richDescription?: { body?: string | null } | null;
		media?: UploadFileFieldsFragment | null;
	};
	let { features }: { features: Feature[] } = $props();
</script>

{#snippet description(feature: Feature)}
	<div class={`flex flex-col max-md:items-center md:w-1/3 md:justify-center`}>
		<h3 class="mb-4 text-4xl font-semibold md:mt-[-48px]">{feature.title}</h3>
		<p class="text-xl">{@html feature.richDescription?.body || feature.description}</p>
	</div>
{/snippet}

{#snippet image(feature: Feature)}
	<div class="md:w-2/3 [&_img]:max-h-[460px]">
		{#if feature.media?.url}
			<Image
				class="rounded-xl drop-shadow-[0_0_8px_rgba(0,0,0,0.25)]"
				src={replaceImg(feature.media.url, 'xlarge')!}
				alt={feature.title}
			/>
		{/if}
	</div>
{/snippet}

<div class="flex flex-col items-center justify-center gap-32">
	{#each features as feature, i}
		<div
			class={`flex w-full max-w-screen-lg flex-row gap-x-6 gap-y-4 ${i % 2 === 0 ? 'max-md:flex-col' : 'max-md:flex-col-reverse'}`}
		>
			{#if (i % 2 === 0 && feature.imagePlacement !== 'left') || feature.imagePlacement === 'right'}
				{@render description(feature)}
				{@render image(feature)}
			{:else}
				{@render image(feature)}
				{@render description(feature)}
			{/if}
		</div>
	{/each}
</div>
